import { WasteLineUnifiedInput } from "generated-graphql/graphql";
import { omit } from "lodash-es";

export const transform = (input: WasteLineUnifiedInput) => {
  return {
    ...omit(input, "eManifestAmount"),
    vendorAmount: input.vendorAmount ? Number(input.vendorAmount) : undefined,
  };
};
